import { COUNTRIES_SORT_COLUMN, ICountriesFilters, ICountryValidation } from '../screens/General/LanguageCountryCurrency/types/countries';
import { LOCALES, SORTING_DIRECTION } from 'src/constants/main';
import { ICountry } from 'src/types/country';

export const defaultCountry: ICountry = {
  id: 0,
  name: {
    en: '',
  },
  place_id: '',
  numeric_code: undefined,
  alfa_2_code: '',
  isd_code: '',
  status: 1,
  created_at: new Date(),
  is_default: 0,
};

export const defaultCountriesFilters: ICountriesFilters = {
  search: '',
  perPage: undefined,
  sortField: COUNTRIES_SORT_COLUMN.NAME,
  sortDir: SORTING_DIRECTION.ASCENDING,
};

export const defaultCountryValidation: ICountryValidation = {
  name: {
    [LOCALES.EN]: {
      state: true,
    },
    [LOCALES.AR]: {
      state: true,
    },
  },
  place_id: {
    state: true,
  },
  numeric_code: {
    state: true,
  },
  alfa_2_code: {
    state: true,
  },
  isd_code: {
    state: true,
  },
};
